import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { connect } from 'react-redux';
import BrandLogoDisplay, {
	BRAND_DISPLAY_TYPE,
} from '../brands_overview_index_page/BrandLogoDisplay';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { ROLE_TYPES } from '../../utils/DataConstants';

const ServiceRequestLocationRender: FC<any> = ({ location, userType }): React.ReactElement => {
	const maxHeight = 108;
	const brandLocationDisplayRef = useRef();
	const ellipsisRef = useRef();

	const [lines, setLines] = useState(5);
	const [loaded, setLoaded] = useState(false);

	const locationName = useMemo(
		() =>
			userType === ROLE_TYPES.SUPPLIER
				? `${nullSafeGet('buyerCompany.name', location)} - ${location.name}`
				: location.name,
		[location, userType]
	);

	useEffect(() => {
		const brandNode = brandLocationDisplayRef.current;
		const ellipsesNode = ellipsisRef.current;
		if (brandNode && ellipsesNode && loaded) {
			const lineHeight = parseFloat(window.getComputedStyle(ellipsesNode).lineHeight) || 20;
			const brandHeight = brandNode.offsetHeight;
			if (brandHeight && lineHeight) {
				setLines(Math.floor((maxHeight - brandHeight) / lineHeight));
			}
		}
	}, [locationName, brandLocationDisplayRef, ellipsisRef, loaded]);

	return (
		<div className="flex flex-row items-center lg:flex-col">
			<span ref={brandLocationDisplayRef}>
				<BrandLogoDisplay
					brand={nullSafeGet('brand', location)}
					displayType={BRAND_DISPLAY_TYPE.WO_CREATION}
					onLoad={() => setLoaded(true)}
				/>
			</span>
			<span ref={ellipsisRef}>
				<Ellipsis
					tooltip={true}
					fullWidthRecognition={true}
					lines={lines}
					style={{
						wordBreak: 'keep-all',
						overflowWrap: 'normal',
					}}
				>
					{locationName}
				</Ellipsis>
			</span>
		</div>
	);
};

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ServiceRequestLocationRender);
